import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ResendConfirmDialogData {
  dispenseOrderId: number;
  orderId: number;
  externalOrderNumber: string;
}

@Component({
  selector: 'resend-confirm-dialog',
  imports: [],
  templateUrl: './resend-confirm-dialog.component.html',
  styleUrl: './resend-confirm-dialog.component.scss',
})
export class ResendConfirmDialogComponent {
  dialogRef = inject<MatDialogRef<ResendConfirmDialogComponent>>(MatDialogRef);
  data = inject<ResendConfirmDialogData>(MAT_DIALOG_DATA);

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
